import Vue from 'vue'
import { STOCK_HALTED_STATUS } from 'const/stock'

// 获取停牌状态
Vue.filter('stockHalted', value => {
  if (value === STOCK_HALTED_STATUS.HALTED) {
    return Vue.t('stock-badges.halted')
  }
  if (value === STOCK_HALTED_STATUS.DELISTED) {
    return Vue.t('stock-badges.delisted')
  }
  if (value === STOCK_HALTED_STATUS.CHANGED) {
    return Vue.t('stock-badges.changed')
  }
})
